import * as React from 'react'

import { cn } from '@/lib/utils'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  inputSize?: 'sm' | 'md' | 'lg' | 'xl'
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize = 'md', error = false, ...props }, ref) => {
    const sizeClasses = {
      sm: 'h-8 px-3 text-xs',
      md: 'h-9 px-4 text-sm',
      lg: 'h-10 px-5 text-sm',
      xl: 'h-11 px-6 text-base',
    }

    return (
      <input
        className={cn(
          cn(
            'flex w-full rounded-md border bg-neutral-50 shadow-sm',
            'transition-colors file:border-0 file:bg-transparent',
            'file:text-sm file:font-medium file:text-gray-900',
            'placeholder:text-gray-400 focus-visible:outline-none',
            'focus-visible:ring-1 disabled:cursor-not-allowed',
            'disabled:opacity-50'
          ),
          error
            ? 'border-red-500 focus-visible:ring-red-500'
            : 'border-neutral-300 focus-visible:ring-neutral-500',
          sizeClasses[inputSize],
          className
        )}
        ref={ref}
        type={type}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
